import { Url } from "@didi/mfe-global-utils";

export const querySet = Url.getQuerySet() as any